import React, { useState, useEffect } from 'react'
import logo from '../Assets/logo.png'
import '../Css/Nav.css'
import { Link, useLocation } from 'react-router-dom';

export default function Nav() {

  const location = useLocation(); // Get the current route path

  // State to hold the search query
  const [query, setQuery] = useState("");

  // Function to handle form submission
  const handleSearch = (event) => {
    event.preventDefault(); // Prevent page reload
    // Redirect to Google search with the query
    if (query) {
      window.location.href = `https://www.google.com/search?q=${query}`;
    }
  };


  // resnavbar
  const [isNavVisible, setIsNavVisible] = useState(false);

  const handleCheckboxChange = () => {
    setIsNavVisible(prevState => !prevState);
  };

  return (
    // <header>
      <div className="main-container-nav">

        <header>
            
            <div className="uper-nav">
              <div className="uper-left">
              <a href="https://www.iitrpr.ac.in/logo-iit-ropar" target="_blank" style={{display:"flex", alignItems:"center"}}> <div className="logo">
                  <img src={logo} alt="" />
                </div>
                <div className="web-heading">
                  <h1 style={{color:"#2c2573"}}>Department of Civil Engineering</h1>
                  <h3>Indian Institute of Technology Ropar</h3>
                </div></a>
              </div>
    
              <div className="uper-right">
                <ul>
                  <div className='li'>
                  <a href="" target="_blank"><li>Booking Portal</li></a>
                  <a href="" target="_blank"><li>Helpdesk</li></a>
                  <a href="" target="_blank"><li>Intranet</li></a>
                  <a href="https://www.iitrpr.ac.in/moodle/" target="_blank"><li>Moodle</li></a>
                  
                  </div>
                  <div className='form'>
                  <form onSubmit={handleSearch}>
                    <input type="text" value={query} className='g-search' onChange={(e) => setQuery(e.target.value)} placeholder='Search IIT Civil Engineering' />
                    <button className='g-btn' type="submit" style={{cursor:"pointer"}}>Search</button>
                  </form>
                  </div>
                </ul>
              </div>
            </div>
        
        </header>

        <nav>
            <div className="lower-nav">
              <ul>
                <Link to="https://www.iitrpr.ac.in/civil/"><li className={location.pathname === "/" ? "active" : ""}>HOME</li></Link>
                <a href="https://www.iitrpr.ac.in/civil/?member_category=faculty" className='multi-items'><li>
                  PEOPLE
                  <div className="more-items" style={{width:"180px"}}>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=faculty"><li>Faculty</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=staff"><li>Staff</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=post-docs"><li>Post-Docs</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=phd-scholars"><li>PhD Scholars</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=pg-students"><li>PG Students</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=ug-students"><li>UG Students</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?member_category=alumni"><li>Alumni</li></a>
                  </div>
                </li></a>
    
                <a href="https://www.iitrpr.ac.in/civil/?page_id=24" className='multi-items'><li>ACADEMICS
                  <div className="more-items" style={{width:"260px"}}>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=27"><li>Undergraduate Program (UG)</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=42"><li>Postgraduate Program (PG)</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=48"><li>Doctoral Program (Ph.D)</li></a>
                  </div>
                  </li></a>
                <a href="https://www.iitrpr.ac.in/civil/?page_id=55"  ><li>GALLERY</li></a>
                <a href="https://www.iitrpr.ac.in/civil/?cat=18"  className='multi-items'><li>
                  NEWS & EVENTS
                  <div className="more-items">
                    <a href="https://www.iitrpr.ac.in/civil/?cat=18"><li>News</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?cat=17"><li>Events</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?cat=28"><li>Achievements</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?cat=29"><li>Awards & Honours</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?cat=37"><li>Invited Lectures</li></a>
                  </div>
                </li></a>
                <a className='multi-items'><li>
                  PROJECT
                  <div className="more-items">
                    <a href="https://www.iitrpr.ac.in/civil-project-ceva/"><li>CEVA</li></a>
                  </div>
                  </li></a>
                <Link to="/research"><li className={location.pathname === "/research" ? "active": ""} >RESEARCH</li></Link>

                <a href="https://www.iitrpr.ac.in/civil/?page_id=58"  className='multi-items'><li>RESOURCES
                  <div className="more-items" style={{width:"240px"}}>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=78" ><li>CAD Lab</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=82" ><li>BIM Lab </li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=84" ><li>Soil Water Plant Lab  </li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=706" ><li>Environmental Engineering</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=767" ><li>Geomatics Engineering</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=836" ><li>Hydraulics Engineering</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=870" ><li>Structural Analysis Lab </li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=890" ><li>Concrete Technology Lab</li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=1073" ><li>Transporation Engineering </li></a>
                    <a href="https://www.iitrpr.ac.in/civil/?page_id=123" ><li>Useful Links </li></a>
                  </div>
                  </li></a>
                <Link to="/consultancy"><li className={location.pathname === "/consultancy" ? "active" : ""}>CONSULTANCY</li></Link>
                <a href="https://www.cesafiesta.tech/" target="_blank"><li>CASAFIESTA</li></a>
                <a href="https://www.iitrpr.ac.in/civil/?page_id=91" ><li>CONTACT</li></a>
              </ul>
            </div>
        </nav>

        {/* ----responsive-nav */}
        <div className="res-div-btn" >
          <label className="res-btn" htmlFor="navigationbtn">Navigation</label>
          <input type="checkbox" id="navigationbtn" onChange={handleCheckboxChange}/>
        </div>

        <div className="res-lower-nav" style={{ display: isNavVisible ? 'block' : 'none' }}>
          <ul>
            <Link to="https://www.iitrpr.ac.in/civil/"><li>Home</li></Link>
            <a href="https://www.iitrpr.ac.in/civil/?member_category=faculty" className='res-multi-items'><li>
              People
              {/* <div className="res-more-items">
                <a href=""><li>Vision and Mission</li></a>
                <a href=""><li>Institute Statutes</li></a>
                <a href=""><li>Act</li></a>
                <a href=""><li>Board of Governors(BOG)</li></a>
                <a href=""><li>Director</li></a>
              </div> */}
            </li></a>

            <a href="https://www.iitrpr.ac.in/civil/?page_id=24"><li>Academics</li></a>
            <a href='https://www.iitrpr.ac.in/civil/?page_id=55' className='res-multi-items'><li>
              Gallery
              {/* <div className="res-more-items">
                <a href=""><li>Artificial Intelligene and Data Engineering</li></a>
                <a href=""><li>BioMedical</li></a>
                <a href=""><li>Chemical</li></a>
                <a href=""><li>Chemistry</li></a>
              </div> */}
            </li></a>
            <a href='https://www.iitrpr.ac.in/civil/?cat=18' className='res-multi-items'><li>
              News & Events   
              {/* <div className="res-more-items">
                <a href=""><li>CARDS</li></a>
              </div> */}
            </li></a>
            <a href="https://www.iitrpr.ac.in/civil-project-ceva/"><li>Project</li></a>
            <Link to="/research"><li>Research</li></Link>

            <a href="https://www.iitrpr.ac.in/civil/?page_id=58"><li>Resources</li></a>
            <Link to="/consultancy" className='res-multi-items'><li>
              Consultancy
              {/* <div className="res-more-items">
                <a href=""><li>Library</li></a>
                <a href=""><li>Medical Center</li></a>
                <a href=""><li>Snehita Well Being</li></a>
                <a href=""><li>Hostel</li></a>
              </div> */}
            </li></Link>
            <a href="https://www.cesafiesta.tech/" target="_blank"><li>CASAFIESTA</li></a>
            <a href="https://www.iitrpr.ac.in/civil/?page_id=91"><li>Contact</li></a>
          </ul>
        </div>





      </div>
    // </header>
  )
}
